import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Small "New" indicator that draws the center's attention to an entry.
 *
 * Same markup as BetaChip, so both sit the same way in a menu row.
 */
export default function NoveltyChip(): React.ReactElement {
    const { t } = useTranslation();

    return (
        <span className="bg-secondary text-secondary-foreground shrink-0 rounded-md px-1 py-0.5 text-[10px] leading-none font-semibold whitespace-nowrap">
            {t('common.novelty')}
        </span>
    );
}
